import { QueryClient } from '@tanstack/react-query';

/**
 * Creates a new React Query client with optimized settings
 * for our application's needs
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // How long to keep data in cache when not being used (5 minutes)
        staleTime: 1000 * 60 * 5,

        // How long to keep data in cache before garbage collection (10 minutes)
        gcTime: 1000 * 60 * 10,

        // Retry failed queries 3 times with exponential backoff
        retry: 3,

        // Don't refetch on window focus by default (can be overridden per query)
        refetchOnWindowFocus: false,

        // Don't refetch on reconnect by default
        refetchOnReconnect: false,
      },
      mutations: {
        // Retry failed mutations once
        retry: 1,

        // Show error notifications for failed mutations
        onError: (error) => {
          console.error('Mutation failed:', error);
          // Later we can add toast notifications here
        },
      },
    },
  });
}

// The QueryClient is created in the QueryProvider component using
// the factory above to ensure proper client-side initialization.
